import { useState, useEffect } from 'react';
import QuickFilter from '../../Common/QuickFilter';
import { getUniqueSortedLabelValuePairsFromNumbers } from '../../utils';

const ShipperQuickFilter = (props) => {
  const [equipPref, setEquipPref] = useState({
    maxEquipSizes: [],
    minEquipSizes: [],
    fixedEquipSizes: []
  });

  useEffect(() => {
    props.glEventHub.on('updatedShipperData', updateShipperData);
    return () => {
      props.glEventHub.off('updatedShipperData', updateShipperData);
    };
  }, [props.glEventHub]);

  const updateShipperData = ({
    maxEquipSizes,
    minEquipSizes,
    fixedEquipSizes
  }) => {
    setEquipPref({
      maxEquipSizes: getUniqueSortedLabelValuePairsFromNumbers(maxEquipSizes),
      minEquipSizes: getUniqueSortedLabelValuePairsFromNumbers(minEquipSizes),
      fixedEquipSizes: getUniqueSortedLabelValuePairsFromNumbers(fixedEquipSizes)
    });
  };

  return (
    <QuickFilter
      key={props.filterName}
      customStore={{
        CustomerStore: {
          ...equipPref
        }
      }}
      {...props}
    />
  );
};

export default ShipperQuickFilter;
